import HttpService from "../http.services";

const apiManagementService = new HttpService(process.env.REACT_APP_API_URL);

class userServiceGloblal {

  getPermissions = async () => {
    return await apiManagementService.post("/apiglobal/v1/usuarios/permisos", {});
  };

  SaveUser = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/saveUser",payload);
  };
 
  getDataUsuarios = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/getDataUsuarios",payload);
  };
  getDataUsuarioId = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/getDataUsuarioId",payload);
  };
  DeleteUsuario = async (payload) => {
    return await apiManagementService.post("/apiglobal/v1/DeleteUsuario",payload);
  };
 


}

const userServiceGloblalInstance = new userServiceGloblal();

export default userServiceGloblalInstance;
